import { render, staticRenderFns } from "./Praesenzliste.vue?vue&type=template&id=6b07ed2f"
import script from "./Praesenzliste.vue?vue&type=script&lang=js"
export * from "./Praesenzliste.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports